import Vue from 'vue';
import VueRouter from 'vue-router';
import { loginRoutes } from '@ulibs/unlogin/routes';
import { dynameatRoutes } from '@dynameat/routes';
import { setupVueRouter } from '@core/helpers/routing';
import NotFoundPage from '@core/components/NotFoundPage.vue';
import { SessionController } from '@core/helpers';
import { PermissionController } from '@core/permissions';

const { isNavigationFailure, NavigationFailureType } = VueRouter;

setupVueRouter();
Vue.use(VueRouter);

const routes = [
  loginRoutes,
  ...dynameatRoutes,
  { path: '*', component: NotFoundPage, name: 'not-found-page' }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.NODE_ENV === 'production' ? '/dynameat/' : '/',
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth) && !SessionController.isValidSession()) {
    try {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } catch (err) {
      if (!isNavigationFailure(err, NavigationFailureType.redirected) && !isNavigationFailure(err, NavigationFailureType.aborted) && !isNavigationFailure(err, NavigationFailureType.duplicated) && !isNavigationFailure(err, NavigationFailureType.cancelled)) {
        next(err);
      } else next();
    }
  } else if (to.matched.some((record) => record.meta.onlyUnauthorized) && SessionController.isValidSession()) {
    next(from.fullPath);
  } else if (to.matched.some((m) => m.meta.requiresAuth) && (!PermissionController.getInstance().isAllowed(to.name) && PermissionController.getInstance().haveRoutes())) {
    next({ name: 'not-found-page', params: { 0: '' } });
  } else {
    next();
  }
});

export { router };
